import React, { useContext, useRef } from "react";
import { useI18n } from "@core/i18n/i18n";
import { getStartedManager } from "@core/service-container";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import { row } from "@ui/style/layout";
import { useDimensions } from "@ui/hooks/use-dimensions";
import { DialogContext, ModalId } from "@ui/components/dialog/dialog-provider";
import { TextInput } from "@ui/components/inputs/text-input";
import { useExercisePage } from "@ui/pages/exercise/hooks/use-exercise-page";
import { exerciseFilterManager } from "@core/service-container";
import { FilterButton } from "@ui/pages/exercise/components/filter-button";

interface SearchFilterProps {
	className?: string;
}

export const SearchFilter: React.FC<SearchFilterProps> = ({ className }) => {
	const { format } = useI18n();
	const { isDesktop } = useDimensions();
	const { search } = useExercisePage();
	const dialogContext = useContext(DialogContext);
	const hasMarkedOnboardingRef = useRef(false);

	return (
		<Container className={className}>
			<Row className="p-input-icon-left p-input-icon-right">
				<i className="pi pi-search" />
				<StyledTextInput
					placeholder={format("searchFilter.searchInputPlaceholder")}
					value={search}
					onChange={e => {
						exerciseFilterManager.searchWord.set(e.target.value);
						if (!hasMarkedOnboardingRef.current) {
							hasMarkedOnboardingRef.current = true;
							void getStartedManager.tryMarkExercisesStepAsCompleted();
						}
					}}
				/>
				<ClearFilterButton
					className="pi pi-times"
					displayed={!!search}
					onClick={() => exerciseFilterManager.searchWord.set("")}
				/>
			</Row>
			{!isDesktop && <FilterButton onClick={() => dialogContext?.openModal(ModalId.ExerciseFilters)} />}
		</Container>
	);
};

const Container = styled.div`
	${row("XS", "flexstart", "center")}
`;

const Row = styled.div`
	flex: 1;
`;

const StyledTextInput = styled(TextInput)`
	width: 100%;
`;

const ClearFilterButton = styled.i<{ displayed: boolean }>`
	cursor: pointer;
	display: ${({ displayed }) => (displayed ? undefined : "none")};

	:hover {
		color: ${colors.primary} !important;
	}
`;
